import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/Charity-Relief-App.png";
import emotion from "../../Assets/Projects/dataAnalyser.png";
import editor from "../../Assets/Projects/Garden-Products.png";
import chatify from "../../Assets/Projects/inasAlu.png";
import suicide from "../../Assets/Projects/NewsLetter.png";
import bitsOfCode from "../../Assets/Projects/Work-Hub.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Aluminum Windows & Doors"
              description="A project focused on building high-quality aluminum windows 
              and doors with glass that can withstand gunshots. Designed with security and durability in mind, providing protection without compromising on style."              
              ghLink="#"
              demoLink="https://inasalu.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Financial Dashboard"
              description="A comprehensive dashboard designed to track financial performance, generate detailed reports, and visualize data with interactive charts. It enables users to monitor key financial metrics, analyze trends, and make informed business decisions, all in one platform."
              ghLink="#"
              demoLink=" https://dashboard.breakoutsandsetups.com/dashboard"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="HR Management System"
              description="A full-stack HR system with an admin dashboard, enabling comprehensive employee management. Features include user account management, task assignment, profile updates, task tracking, and mail notifications. Built with React, Node.js, MongoDB, and integrated with Paytm for payments and Sendgrid for email services."
              ghLink="#"
              demoLink="https://work-hub.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="NYC Garden Store"
              description="A small plant store with three locations across NYC. Offering a wide variety of plants, customers can shop in-store or conveniently order online. We provide everything needed to create a beautiful garden, with expert advice and quality plants delivered right to your door."
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://secret-garden.webflow.io/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="SafEarth Relief App"
              description="SafEarth is a relief app developed to assist people globally during earthquakes. Users can report quake data, and the app marks affected areas around the epicenter. It includes a blog, PDF generator, and services like extracting text from images, processing up to 1000 images. Users can customize PDFs and analyze headers and paragraphs for easy content management. SafEarth is more than just an app; it's a collaborative movement uniting diverse people to create positive change."
              ghLink="#"
              demoLink="https://safearth.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Donation Blog Platform"
              description="A blog platform that integrates the New York Times API to provide users with the latest news while raising awareness for donation collections. The platform allows organizations to share stories, attract support, and drive contributions to help those in need. Combining real-time news updates with a mission to make a difference, it offers a unique space for both information and impact."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              demoLink="https://safearth.onrender.com/blog"
            />
          </Col>

         
        </Row>


      </Container>
    </Container>
  );
}

export default Projects;
